import React from "react";


const CreateCardForm = () => {
    return (
        <form>
            <div className="settings-list-wrapper">
                <div className="single-settings">
                    <h5 className="setting-title">Profile Photo</h5>
                    <div className="setting-content">
                        <div className="sng-content-repeater business-profile">
                            <div className="sng-content">
                                <h5>Browse photo</h5>
                                <label for="ProfilePhoto">
                                    <i className="ri-edit-2-line"></i>
                                    <input id="ProfilePhoto" type="file" className="sett-form-input" name="ProfilePhoto" />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="single-settings">
                    <h5 className="setting-title">Contact Information</h5>
                    <div className="setting-content">
                        <div className="sng-content-repeater">
                            <div className="sng-content">
                                <label>Name</label>
                                <input type="text" className="sett-form-input" name="name" placeholder="e.g. Jhon Doe" />
                            </div>
                        </div>
                        <div className="sng-content-repeater">
                            <div className="sng-content">
                                <label>Phone</label>
                                <input className="sett-form-input" name="Phone" placeholder="+1 123 234 564" />
                            </div>
                        </div>
                        <div className="sng-content-repeater">
                            <div className="sng-content">
                                <label>Email</label>
                                <input type="email" className="sett-form-input" name="Email" placeholder="e.g. jhondow007@mail.com" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="single-settings">
                    <h5 className="setting-title">Business Information</h5>
                    <div className="setting-content">
                        <div className="sng-content-repeater"> 
                            <div className="sng-content">
                                <label>Job title</label>
                                <input type="text" className="sett-form-input" name="jobtitle" placeholder="e.g. Developer" />
                            </div>
                        </div>
                        <div className="sng-content-repeater"> 
                            <div className="sng-content">
                                <label>Address</label>
                                <input type="text" className="sett-form-input" name="address" placeholder="235 park street, NY" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="button-wrapper">
                    <button className="btn cancel-btn">Cancel</button>
                    <button className="btn submit-btn bg-primary">Submit</button>
                </div>
            </div>
        </form>
    );
}

export default CreateCardForm;
